var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-container"},_vm._l((_vm.alerts),function(alert,index){return _c('v-alert',{key:index,staticClass:"my-alert",attrs:{"dismissible":"","width":"350px","dark":"","dense":"","type":alert.type,"border":"left","elevation":"2","prominent":""}},[_vm._v(" "+_vm._s(alert.message)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }